import React from 'react'
import { Link } from 'react-router-dom'

const SettingCard = ({url,icon,title,info}) => {
  return (
    <Link to={url} className='settingCard'>
        <img className='icon' src={icon} alt="icon" />
        <h1 className='title'>{title}</h1>
        <p className='info'>{info}</p>
    </Link>
  )
}

export default SettingCard